'use strict';

import React, { createContext, useContext, useState, useEffect } from 'react';

import appStore from "./AppStore";
import history from "./History";

/**
 * This needs to be defined here rather than in an app's index.js so that it can be independently be imported into
 * components that need access to appStore or browser history.
 *
 * In React components (e.g. App.jsx), import AppContext via:
 *      import {AppContext} from "@uw-it-sis/lib-react/lib/AppContext";
 *
 * then you can go:
 *
 *      static contextType = AppContext;
 *
 *      someLifecycleMethod() {
 *          this.context.appStore.someMethod()
 *          this.context.history.someHistoryCall()
 *      }
 *
 * Or in functional components, import AppContext via:
 *      import {useAppContext} from "@uw-it-sis/lib-react/lib/AppContext";
 *
 * then you can go:
 *
 * const MyComponent = (props) => {
 *      const context = useAppContext();
 *
 */

// Leaving AppContext for export until old references can be updated.
const AppContext = createContext({});

// Provider wrapper for App component with appStore and history
const AppProvider = ({children}) => {
    const appValues = {
        appStore: appStore,
        history: history,
    };

    return (
        <AppContext.Provider value={appValues}>
            {children}
        </AppContext.Provider>
    );
}

const useAppContext = () => useContext(AppContext);

export {AppContext, AppProvider, useAppContext};